import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ErrorBannerProps {
  message: string;
  onDismiss?: () => void;
  className?: string;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  onDismiss,
  className,
}) => (
  <div className={cn(
    'flex items-center gap-3 bg-error-50 border border-error-200 text-error-800 px-4 py-3 rounded-lg',
    className
  )}>
    <AlertCircle className="w-5 h-5 text-error-600 flex-shrink-0" />
    <p className="flex-1 text-sm font-medium">{message}</p>
    {onDismiss && (
      <button
        onClick={onDismiss}
        className="text-error-600 hover:text-error-800 transition-colors"
        aria-label="Dismiss error"
      >
        <X className="w-4 h-4" />
      </button>
    )}
  </div>
);